var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 38C29.7173 38 38 29.7173 38 19.5C38 9.28273 29.7173 1 19.5 1C9.28273 1 1 9.28273 1 19.5C1 29.7173 9.28273 38 19.5 38Z",
    fill: "white",
    stroke: "#3D8EE8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 13.4922H29.0578C29.8264 13.4922 30.4507 14.1165 30.4507 14.8851V27.9221C30.4507 28.6908 29.8264 29.315 29.0578 29.315H26.375V13.4941V13.4922Z",
    fill: "#3D8EE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95153 13.4941H12.6343V29.3151H9.95153C9.18288 29.3151 8.55859 28.6908 8.55859 27.9221V14.8851C8.55859 14.1165 9.18288 13.4922 9.95153 13.4922V13.4941Z",
    fill: "#3D8EE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3634 13.4922H13.6406V29.3132H25.3634V13.4922Z",
    fill: "#3D8EE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5767 10.752V13.4929H21.6768V11.5582C21.6768 11.0857 21.2925 10.7014 20.8182 10.7014H18.1804C17.7061 10.7014 17.3218 11.0857 17.3218 11.5582V13.4929H16.4219V10.752C16.4219 10.1596 16.9018 9.67969 17.4942 9.67969H21.5024C22.0949 9.67969 22.5748 10.1596 22.5748 10.752H22.5767Z",
    fill: "#3D8EE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.965815a9c82b4ec693f532c64712e3af.svg";
export { ForwardRef as ReactComponent };